import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "dropdown"]

  show() {
    const dropdown = this.dropdownTarget
    dropdown.classList.remove("d-none")

    // If using fixed positioning (for providers hover), calculate position
    if (getComputedStyle(dropdown).position === 'fixed') {
      const triggerRect = this.triggerTarget.getBoundingClientRect()
      dropdown.style.top = `${triggerRect.bottom + 8}px`
      dropdown.style.left = `${triggerRect.left}px`
    }
  }

  hide() {
    this.dropdownTarget.classList.add("d-none")
  }

  toggle() {
    if (this.dropdownTarget.classList.contains("d-none")) {
      this.show()
    } else {
      this.hide()
    }
  }

  hideIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
